import React from 'react';
import PropTypes from 'prop-types';

import styles from '../../../../utils/styles';
import './typography-heading.scss';

export interface ITypographyHeadingComponent {
  custom?: boolean;
  text: string;
  headingTag: string;
  customFont?: string;
}

const classMap = {
  h1: 'ty-heading--l',
  h2: 'ty-heading--m',
  h3: 'ty-heading--s',
  custom: 'ty-heading-m-custom',
};

const TypograpyHeadingComponent: React.FC<ITypographyHeadingComponent> = ({
  text = '',
  headingTag = 'h1',
  custom = false,
  customFont = undefined,
}) =>
  React.createElement(
    headingTag,
    { className: `${styles(classMap[custom ? 'custom' : headingTag])} ${styles(customFont || '')}` },
    `${text}`
  );

TypograpyHeadingComponent.propTypes = {
  custom: PropTypes.bool,
  customFont: PropTypes.string,
  headingTag: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
};

export default TypograpyHeadingComponent;
